import { Text } from "../../../../core/Text.js";
import type { FairnessIntroContent } from "../../fairnessContent.js";

/** The page's one h1 and what provably fair means here. */
export function FairnessIntro({ title, body }: FairnessIntroContent) {
  return (
    <div className="flex max-w-2xl flex-col gap-3">
      <Text as="h1" variant="display-xl2" tone="primary" className="max-md:text-display-xl3">
        {title}
      </Text>
      <Text variant="body-b1" tone="secondary">
        {body}
      </Text>
    </div>
  );
}
